import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
  FacilityPatientDetailsDto,
} from 'webcommon/shared';

import { FacilityPortalHttpClientService } from '../FacilityPortalHttpClientService';

@Injectable({
  providedIn: 'root',
})
export class FpPatientRepository {
  constructor(
    private httpClientService: FacilityPortalHttpClientService,
  ) { }

  getFacilityPatientDetails(userId: string): Observable<FacilityPatientDetailsDto> {
    const endpointUrl = `patient/${userId}/new-message-details`;
    return this.httpClientService.sendGetRequest(endpointUrl);
  }
}
